import React from 'react'
import { Grid, Typography } from '@material-ui/core/'
import { DialogModal, Button } from '../../../components/UI'
import './index.scss'

const DeleteModal = ({ open, onClose, text, onDelete, story }) => (
  <DialogModal
    top='50%'
    width='90%'
    maxWidth='320px'
    onClose={onClose}
    closeBtn
    open={open}
  >
    <Grid className='deleteModalWrapper' container direction='column' alignItems='center'>
      <Typography className='deleteModalTitle' align='center'>
        Are you sure that you want to delete {text}?<br />
        {story && 'You cannot undo this action.'}
      </Typography>
      <Grid className='btnContainer' container justify='space-between'>
        <Button onClick={onClose} className='canselBtn'>Cancel</Button>
        <Button className='deleteBtn' onClick={onDelete}>Delete</Button>
      </Grid>
    </Grid>
  </DialogModal>
)

export default DeleteModal
